import React, { useState, useEffect } from 'react';
import './dreamie-display.scss';
import { ReactComponent as LoadingRingsIcon } from '../../../icons/loading-rings.svg';
import { useAgent } from '../../../contexts/AgentContext';

interface DreamieDisplayProps {
  imageUrl?: string;
  predominantColour?: string;
  agentName?: string;
  agentId?: string; // Optional: fetch agent data by ID
}

const DreamieDisplay: React.FC<DreamieDisplayProps> = ({
  imageUrl: propImageUrl,
  predominantColour: propPredominantColour,
  agentName: propAgentName,
  agentId,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { agents } = useAgent();

  // Determine which values to use - from agentId lookup or from props
  const agent = agentId ? agents.find((a) => a.id === agentId) : null;
  const imageUrl = agent?.image_url || propImageUrl;
  const predominantColour = agent?.predominant_colour || propPredominantColour;
  const agentName = agent?.name || propAgentName;

  useEffect(() => {
    if (!imageUrl) return;

    setIsLoading(true);
    setError(null);

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      setIsLoading(false);
    };

    img.onerror = () => {
      setIsLoading(false);
      setError('Failed to load image');
    };

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [imageUrl]);

  if (!imageUrl) return null;

  return (
    <div className='dreamie-display-container'>
      {isLoading ? (
        <div className='dreamie-loading'>
          <LoadingRingsIcon />
        </div>
      ) : (
        <div
          className='dreamie-image'
          style={{
            background: `url(${imageUrl})  50% / contain no-repeat`,
          }}
          title={agentName || 'Agent dreamie'}
        />
      )}
    </div>
  );
};

export default DreamieDisplay;
